<!--
個人志 PersonalCollection.vue
-->

<template>
  <transition title="el-fade-in-linear">
    <div>
      <el-row style="margin:auto;">
        <h2 style="text-align:center">个人志代理</h2>
        <br>
        <el-collapse v-model="InformationCollapse">
          <el-collapse-item title="个人志说明" name="个人志说明">
            <p v-html="个人志说明" style="font-size:130%"></p>
          </el-collapse-item>
        </el-collapse>
        <br>
        <center>
          <el-button v-on:click="addEvent()" style="margin-right:5px">提交</el-button>
        </center>
      </el-row>
    </div>
  </transition>
</template>
<style>
</style>
<script lang="ts">
export default {
  name: "PersonalCollection",
  methods: {
    addEvent: function() {
      this.$root.add(this.personalCollectionFormData);
      this.clear();
    },
    clear: function() {
      this.personalCollectionFormData = {
        title: "个人志代理",
        留言内容: "申请个人志代理"
      };
    }
  },
  data() {
    return {
      personalCollectionFormData: {
        title: "个人志代理",
        留言内容: "申请个人志代理"
      },
      个人志说明: `<p>“个⼈志代理”服务，是漫寻⾕⾯向有推出⾃⼰的个⼈志意愿的作者，推出的⼀项个性化定制服务。</p>
<p>在这项服务中，作者可以将从包括选题、定位等催本的前期过程，到打样、印制，再到发⾏、贩售等后续环节，都授权给漫寻⾕，⽽漫寻⾕所属的专业主催或相关专业⼈⼠，将负责具体的实施。相对的，在此过程期间，作者只需安⼼创作。</p>
<p>通过漫寻⾕的全⽅位⽀持，作者可以将更多的精⼒集中于创作，并在成品产出后，享受到更多的便利。</p>
<p>当然，由于“个⼈志代理”服务需要漫寻⾕的深⼊参与，付出较多的时间、精⼒，所以此项服务会有其特定的安排周期，与必须作者配合的⼀些事项。</p>
<p>想了解关于“个⼈志代理”服务的更多细节，或是想直接体验我们“个⼈志代理”服务的作者，可以点击底部提交按钮，我们将有专员联系您</p>`,
      InformationCollapse: ["个人志说明"]
    };
  }
};
</script>
>